<template>
  <div class="form-group" :class="getClasses()">
    <label v-if="label" :for="name" class="text-info">{{ label }}</label>
    <textarea @input="updateValue($event.target.value)"
              @keypress.enter="enterEvent"
              :value="value | br2nl"
              :name="name"
              :rows="rows || null"
              :required="required"
              :placeholder="placeholder"
              :disabled="disabled"
              class="form-control"
    ></textarea>
    <span v-if="error" class="help-block" v-html="error"></span>
  </div>
</template>

<script>
  export default{
    name: 'InputTextarea',
    props: ['name', 'value', 'required', 'label', 'placeholder', 'error', 'rows', 'disabled', 'classes'],
    methods: {
      enterEvent (e) {
        this.$emit('enter', e)
      },
      updateValue (value) {
        this.$emit('input', value)
      },
      getClasses () {
        let str = this.error ? 'has-error ' : ''
        if (this.classes) str += this.classes
        return str
      }
    }
  }
</script>


// WEBPACK FOOTER //
// InputTextarea.vue?70fafca6